import { FileReader, FileWriter } from '@/platform'
import FileName from '../ComControl/FileName'
import FontProperty from '../MallNewClass/FontProperty'
import PropertyViewPort from './PropertyViewPort'
import GoodPropertyModel from '../GoodPropertyModel'

class WelfareGoods {
    public static readonly CONDITION_CHARGE_MIN: number = 0
    public static readonly CONDITION_CHARGE_MAX: number = 99990
    public static readonly CONDITION_CHARGE_PAKORAS_MIN: number = 0
    public static readonly CONDITION_CHARGE_PAKORAS_MAX: number = 1999800

    public static readonly CONDITION_ACCUMULATIVE_MIN: number = 1
    public static readonly CONDITION_ACCUMULATIVE_MAX: number = 99

    public static readonly CONDITION_WEEK_MIN: number = 1
    public static readonly CONDITION_WEEK_MAX: number = 7

    public static readonly CONDITION_NEW_MIN: number = 1
    public static readonly CONDITION_NEW_MAX: number = 99

    public ID: number = 0 // 商品ID
    public X: number = 0 // 商品X坐标
    public Y: number = 0 // 商品Y坐标
    public Name: string = '商品' // 商品名称
    public NameFont: FontProperty = new FontProperty('宋体', 12, '94,88,76') // 商品名称文字属性
    public NameX: number = 0 // 商品名称的X坐标
    public NameY: number = 0 // 商品名称的Y坐标
    public Image: FileName = new FileName({ type: FileName.DEF_TYPE, name: '福利_icon.png' }) // 图标
    public ViewImage: PropertyViewPort = new PropertyViewPort() // 图标坐标
    public FlowerIsShow: boolean = false // 是否显示鲜花
    public FlowerX: number = 0 // 鲜花X坐标
    public FlowerY: number = 0 // 鲜花Y坐标
    public ViewReceivedLogo: PropertyViewPort = new PropertyViewPort() // 已领取标识坐标
    public ReceivingCondition: number = 0 // 领取条件
    public ReceivingConditionPakoras: number = 0 // 领取条件丸子
    public ReceivingConditionDiscription: string = '' // 领取条件描述
    public ReceivingConditionDiscriptionPakoras: string = '' // 领取条件描述丸子
    public ReceivingConditionX: number = 0 // 领取条件X坐标
    public ReceivingConditionY: number = 0 // 领取条件Y坐标
    public PropertyList: GoodPropertyModel[] = [] // 数值属性集合
    public ExpandStr: string = '' // 扩展字段

    readVersionedOui(reader: FileReader): void {
        this.ID = reader.readInt()
        this.X = reader.readInt()
        this.Y = reader.readInt()
        this.Name = reader.readString()
        this.NameFont.readVersionedOui(reader.readObj(reader.readInt()))
        this.NameX = reader.readInt()
        this.NameY = reader.readInt()
        this.Image.readVersionedOui(reader.readObj(reader.readInt()))
        this.ViewImage.readVersionedOui(reader.readObj(reader.readInt()))
        this.FlowerIsShow = reader.readInt() == 1 ? true : false
        this.FlowerX = reader.readInt()
        this.FlowerY = reader.readInt()
        this.ViewReceivedLogo.readVersionedOui(reader.readObj(reader.readInt()))
        this.ReceivingCondition = reader.readInt()
        this.ReceivingConditionDiscription = reader.readString()
        this.ReceivingConditionX = reader.readInt()
        this.ReceivingConditionY = reader.readInt()

        const propertyLen = reader.readInt()
        for (let i = 0; i < propertyLen; i++) {
            const property = new GoodPropertyModel()
            property.readVersionedOui(reader.readObj(reader.readInt()))
            this.PropertyList.push(property)
        }
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()
        writer.writeInt(this.ID)
        writer.writeInt(this.X)
        writer.writeInt(this.Y)
        writer.writeString(this.Name)
        this.NameFont.writeVersionedOui(writer)
        writer.writeInt(this.NameX)
        writer.writeInt(this.NameY)
        this.Image.writeVersionedOui(writer)
        this.ViewImage.writeVersionedOui(writer)
        writer.writeInt(this.FlowerIsShow ? 1 : 0)
        writer.writeInt(this.FlowerX)
        writer.writeInt(this.FlowerY)
        this.ViewReceivedLogo.writeVersionedOui(writer)
        writer.writeInt(this.ReceivingCondition)
        writer.writeString(this.ReceivingConditionDiscription)
        writer.writeInt(this.ReceivingConditionX)
        writer.writeInt(this.ReceivingConditionY)

        writer.writeInt(this.PropertyList.length)
        for (let i = 0; i < this.PropertyList.length; i++) {
            const property = this.PropertyList[i]
            property.writeVersionedOui(writer)
        }

        writer.writerLength()
    }
}

export default WelfareGoods
